declare const window;
console.log(`global.js`, window);
import "regenerator-runtime/runtime.js"; //必须，才能使用async await 之类的
import knex from "knex";
window["knex"] = knex;
import { nanoid, customAlphabet } from "nanoid/non-secure";
window["customAlphabet"] = customAlphabet;
//全局变量
const globalVars = ["Web_Host", "globalSonAppMainNavConfig", "customAlphabet"];
for (let i = 0; i < globalVars.length; i++) {
  let cName = globalVars[i];
  if (window[cName] === undefined) {
    document.body.innerHTML = `<div>!window.${cName}.全局变量未设置</div>`;
    break;
  }
}

//基础的
const basicComs = ["System", "EventEmitter3"];
for (let i = 0; i < basicComs.length; i++) {
  let cName = basicComs[i];
  if (window[cName] === undefined) {
    document.body.innerHTML = `<div>!window.${cName}.请检查CDN服务是否启动</div>`;
    break;
  }
}

//全局数据监听、发布、订阅对象
window.eventEmitterGlobal = new window.EventEmitter3();
